import CRUDActions from '../CRUD';
import FafFeedSlideshow from '../../api/fan_feed/fan_feed_slideshow';

class FafFeedSlideshowCrud extends CRUDActions {
  prefix = 'fan_feed_slideshow';

  get _model() {
    return FafFeedSlideshow;
  }

}

export default new FafFeedSlideshowCrud();




// WEBPACK FOOTER //
// ./src/actions/fan_feed/fan_feed_slideshow.ts